import { render } from "./quiz-v1-question-option.vue?vue&type=template&id=301c905c&scoped=true"
import script from "./quiz-v1-question-option.vue?vue&type=script&lang=js"
export * from "./quiz-v1-question-option.vue?vue&type=script&lang=js"

import "./quiz-v1-question-option.vue?vue&type=style&index=0&id=301c905c&lang=sass&scoped=true"

import exportComponent from "../../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-301c905c"]])

export default __exports__